import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useLocation } from "react-router-dom";
// material ui
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  FormHelperText,
  Select,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
// icons
import SettingsIcon from "@mui/icons-material/Settings";
import VisibilityIcon from '@mui/icons-material/Visibility';
import HelpIcon from "@mui/icons-material/Help";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';

import ViewCozyIcon from '@mui/icons-material/ViewCozy';
import SummarizeIcon from "@mui/icons-material/Summarize";
import DeleteIcon from "@mui/icons-material/Delete";
// components
import Layout from "../../layout/Layout";
import {
  MuiDataGrid,
  GridCellExpand,
  ModalPopUp,
  FormSubmitButton,
  FormTextField as MyTextInput,
  Notifier,
  ErrorNotifier,
  ModalCloseBtn,
  ConfirmDialog,
  MuiTooltip,
  MuiAutocomplete,
  CommonCurdPopUp
} from "../../components";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";
import MicrositeConfirmDialog from "../customer_management/microsites/MicrositeConfirmDialog";
// redux
import {
  createAssessmentTemplate,
  createAssessmentTemplateByPreDefined,
  getAssessmentTemplate,
  updateAssessmentTemplate,
  deleteAssessmentTemplate,
  forceDeleteAssessmentTemplate,
  copyAssessmentTemplate,
  updateArchivedAssessmentTemplate,
  getAssessmentTemplateBycustomerId,
  getAssessmentTemplateByAccountId,
  getArchivedAssessmentTemplate,
  rowSelect,
  resetMessage,
  resetErrMessage,
  rowSelectEmpty
} from "../../features/prepare_assessments/prepareAssessmentSlice";
import { getPlatformStatus } from "../../features/config/platformStatusSlice";

import { getAssessmentTemplateConfig } from "../../features/config/assessmentTemplateConfigSlice";
import { getAssessmentCompletedFramework } from "../../features/config/assessmentFrameworkConfigSlice";

import { getCustomer } from "../../features/customer/customerSlice";
import { getAccount, getAccountById } from "../../features/customer/accountSlice";
import RadorGraph from "./radorGraph"
import { getassessmentType, setAssessmentType } from "../../features/config/assessmentTypeSlice";
import { sectionRowSelect } from '../../features/prepare_assessments/assessmentTemplateSectionSlice';

// ------------------------------------------------------------------------------

const validationSchema = Yup.object({
  templateDisplayName: Yup.string().required(
    "Template Display Name is required"
  ),

  templateName: Yup.string().required("Template Name is required"),
  description: Yup.string().required("Description is required"),
  comments: Yup.string(),

});

const validationSchemaPreDefine = Yup.object({
  custName: Yup.object().nullable().required("Customer Name is required"),
  accountName: Yup.object().nullable().required("Account Name is required"),
  assessmentType: Yup.object().nullable().required("Assessment Type is required"),
  preTemplateName: Yup.object()
    .nullable()
    .required("Assessment Framework is required"),
});

const editValidationSchema = Yup.object({
  templateDisplayName: Yup.string().matches(/\S/, "Template Display Name cannot be just white spaces").required(
    "Template Display Name is required"
  ),
  custName: Yup.string().nullable().required("Customer Name is required"),
  accountName: Yup.string().nullable().required("Account Name is required"),
  templateName: Yup.string().matches(/\S/, "Template Name cannot be just white spaces").required("Template Name is required"),
  status: Yup.string().required("Status is required"),
  description: Yup.string().required("Description is required"),
  comments: Yup.string().nullable(),
});

// -------------------------------------------------------------------------

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const useStyles = makeStyles((theme) => ({
  rootbox: {
    position: "absolute !important",
    top: "50% !important",
    left: "60% !important",
    transform: "translate(-50%, -50%) !important",
    width: "56.25rem !important",
    [theme.breakpoints.down("sm")]: {
      width: "17.75rem !important",
      height: "44% !important",
      // display:'block !important',
      // overflow:'scroll !important',
      marginTop: "-8.25rem",
      marginLeft: "-0.938rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "24.375rem  !important",
      height: "34% !important",
      display: "block !important",
      overflow: "scroll !important",
      // margin: '-3.188rem',
      marginTop: "-3.75rem  !important",
      marginLeft: "-3.563rem",
      padding: "2.125rem !important",
    },
    background: "#fff !important",
    borderRadius: "0.313rem !important",
    boxShadow: "1.5rem !important",
    paddingTop: "1rem !important",
    paddingLeft: "2rem !important",
    paddingRight: "2rem !important",
    paddingBottom: "1.5rem",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },

  responsive_text: {
    width: "50rem",
    [theme.breakpoints.down("md")]: {
      width: "13rem",
    },
  },
}));
// ------------------------------------------------------------------------

const PrepareAssessments = (props) => {

  // const [assessmentType, setAssessmentType] = useState(null)
  const [showAdd, setShowAdd] = useState(false);
  const [showGraph, setShowGraph] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [viewArchived, setViewArchived] = useState(false)

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [forceDelConfirmDialog, setForceDelConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [copyLoading, setCopyLoading] = useState(false);
  const [templateCreation, setTemplateCreation] = useState("pre-defined");
  const [selectedCustValue, setSelectedCustValue] = useState(null)
  const [selectedAccountValue, setSelectedAccountValue] = useState(null)
  const dispatch = useDispatch();

  const location = useLocation();
  const { customersData } =
    useSelector((state) => ({ ...state.customer }));

  const { accountIdData,selectedAccountDataList, selectedCustomerDataList } = useSelector(
    (state) => ({
      ...state.account,
    })
  );
  const { assessmentTypeData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));




  const { message, errMessage, assessmentTemplateData, selectedData, loading } =
    useSelector((state) => ({ ...state.prepareAssessment }));
  const { errMessage: assessmentErrMessage } =
    useSelector((state) => ({ ...state.assessmentFrameworkConfig }));
  const [selectStateData, setSelectStateData] = useState(selectedData)

  const { assessmentTemplateStatusData } = useSelector((state) => ({
    ...state.assessmentTemplateStatus,
  }));

  const { assessmentFrameworkCompletedData } =
    useSelector((state) => ({ ...state.assessmentFrameworkConfig }));


  const showAddModel = () => {
    setShowAdd(!showAdd);
  };

  const closeModel = () => {
    setShowAdd(false);
    const { accountName, custName } = formik?.values
    formik.resetForm({
      values: {
        accountName: selectedCustValue ? accountName : null,
        custName: selectedCustValue ? custName : null,
        assessmentType: assessmentType,
        templateName: "",
        description: "",
        comments: "",
      },
    })

    // formik.resetForm({
    //   values: {
    //     accountName: "",
    //     custName: "",
    //     templateName: "",
    //     description: "",
    //     comments: "",
    //   },
    // })

    // dispatch(getassessmentType())
    setTemplateCreation("new");
  };

  const showEditModal = () => {
    setShowEdit(true);
    // if (selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id) {
    //   dispatch(getAccountById({ assessmentCustomerId: selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id }))
    // }
    // let resultOne = customersData?.find((dataTwo) => dataTwo?.id === selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id)
    // formikEdit.setFieldValue("custName", resultOne)
  };

  const closeEditModal = () => {
    setShowEdit(false);

    formikEdit.resetForm({
      values: {

        templateName: "",
        description: "",
        comments: "",
        custName: "",
        accountName: "",
      },
    });

  };

  const showDelete = () =>
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDeleteCustomer(),
    });

  const handleDeleteCustomer = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deleteAssessmentTemplate(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          //     selectedCustValue && !selectedAccountValue ?
          //       dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
          //       : selectedAccountValue
          //         ? dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
          //         : dispatch(getAssessmentTemplate());
          //   }, 2000);
          // }
          if (selectedCustValue && selectedAccountValue) {
            dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
          }
          else if (selectedCustValue) {
            dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
          }
          else {
            dispatch(getAssessmentTemplate())
          }
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const showForceDelete = (dataId) =>
    setForceDelConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: (pass) => handleForceDeleteAssessmentTemplate(pass, dataId),
    });

  const handleForceDeleteAssessmentTemplate = (pass, dataId) => {
    let data = {
      id: dataId?.id,
      password: pass,
    };
    dispatch(forceDeleteAssessmentTemplate(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setForceDelConfirmDialog({
            ...forceDelConfirmDialog,
            isOpen: false,
          });
          selectedCustValue && !selectedAccountValue ?
            dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
            : selectedAccountValue
              ? dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
              : dispatch(getAssessmentTemplate());
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 2000);
      }
    });
  };

  const handleSetForceDelConfirmDialog = (obj) => {
    setForceDelConfirmDialog({
      ...forceDelConfirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const classes = useStyles();

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: assessmentType ? assessmentTemplateData?.filter((data) => data.
      assessmentType?.assessmentType === assessmentType?.assessmentType) : assessmentTemplateData?.length > 0 ? assessmentTemplateData : [],
    columns: [

      {
        field: "assessmentTemplateName",
        headerName: "Assessment Template Name",
        width: 250,
        renderCell: renderCellExpand,
      },
      {
        field: "assessmentTemplateDisplayName",
        headerName: "Template Display Name",
        width: 250,
        renderCell: renderCellExpand,
      },

      {
        field: "assessmentType",
        headerName: "Assessment Type",
        width: 250,
        renderCell: renderCellExpand,
        valueGetter: (value,  params) => params?.assessmentType?.assessmentType
      },

      {
        field: "status",
        headerName: "Template Status",
        width: 150,
        renderCell: renderCellExpand,
      },



       ...(!viewArchived ?  [{
        field: "config",
        // hide: viewArchived ? true : false,

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {
          return (
            <MuiTooltip title="Sections & Dimensions" placement="right">
              {!params?.row?.isArchived && <Link
                aria-label="Sections & Dimensions"
                to="/exco/prepare/section-dimension"
                state={{
                  templateSelectedData: params?.row,
                  permissions: location?.state?.permissions,
                  assessmentType: assessmentType,
                  selectedCustValue: selectedCustValue,
                  selectedAccountValue: selectedAccountValue
                }}
              >
                <IconButton aria-label="setting" sx={{ p: 0 }}>
                  <SettingsIcon style={{ color: "#808080" }} />
                </IconButton>
              </Link>}
            </MuiTooltip>
          );
        },
      }]:[]),

    ...(!viewArchived ? [{
        field: "prepareQuestion",
        // hide: viewArchived ? true : false,

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {
          return (
            <MuiTooltip title="Questions" placement="right">
              {!params?.row?.isArchived && <Link
                aria-label="Questions"
                to="/exco/prepare/prepare-questions"
                state={{
                  templateSelectedData: params?.row,
                  permissions: location?.state?.permissions,
                  assessmentType: assessmentType,
                  selectedCustValue: selectedCustValue,
                  selectedAccountValue: selectedAccountValue
                }}
              >
                <IconButton aria-label="help" sx={{ p: 0 }}>
                  <HelpIcon style={{ color: "#808080" }} />
                </IconButton>
              </Link>}
            </MuiTooltip>
          );
        },
      }]:[]),

      //  ...( (location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "cloneAssessTemp")) &&
      ...(!viewArchived ?  [{
        field: "copyAssessment",
        hide: viewArchived ? true : false,
        headerName: location?.state?.permissions?.find(
          (e) =>
            e.applicationService?.name?.split(".")[
            e?.applicationService?.name?.split(".")?.length - 1
            ] === "cloneAssessTemp"
        ) ? "Clone" : "",
        type: "actions",

        width: 70,
        renderCell: (params) => {
          return (
            <MuiTooltip title="Clone Template" placement="right">
              <Link
                 aria-label="Clone Template"
                to="/exco/prepare"
                state={{
                  templateSelectedData: params?.row,
                  permissions: location?.state?.permissions,
                }}
              >
                {
                  location?.state?.permissions?.find(
                    (e) =>
                      e.applicationService?.name?.split(".")[
                      e?.applicationService?.name?.split(".")?.length - 1
                      ] === "cloneAssessTemp"
                  ) && !params?.row?.isArchived && (
                    <IconButton
                      aria-label="file-copy"
                      sx={{ p: 0 }}
                      onClick={() =>
                        dispatch(
                          copyAssessmentTemplate({

                            id: params?.row?.id,
                            assessmentCustomerAccountId: params?.row?.
                              assessmentCustomerAccount?.id

                          })
                        ).then((res) => {
                          if (res?.payload?.data?.ok) {
                            setCopyLoading(true);
                            setTimeout(() => {
                              dispatch(resetMessage());
                              // given condition once the cloned button is clicked based on the selected account and 
                              // customer the get API's data will vary and we will call the API
                              if (selectedCustValue && selectedAccountValue) {
                                dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
                              } else if (selectedCustValue) {
                                dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
                              } else {
                                dispatch(getAssessmentTemplate());
                              }
                              setCopyLoading(false);
                            }, 2000);
                          }
                          if (res?.payload?.error) {
                            setTimeout(() => {
                              dispatch(resetErrMessage());
                            }, 3000);
                          }
                        })
                      }
                      disabled={copyLoading}
                    >
                      <FileCopyIcon style={{ color: "#808080" }} />
                    </IconButton>
                  )}
              </Link>
            </MuiTooltip>
          );
        },
      }]:[]),

      {
        field: "archived",

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {
          return (
            <MuiTooltip title={!params?.row?.isArchived ? "Archive" : "UnArchive"} placement="right">
              {!params?.row?.isArchived ? <IconButton
               aria-label="archive"
                onClick={() => dispatch(
                  updateArchivedAssessmentTemplate({

                    id: params?.row?.id,
                    isArchived: true

                  })
                ).then((res) => {
                  if (res?.payload?.data?.ok) {
                    // setCopyLoading(true);
                    setTimeout(() => {
                      dispatch(resetMessage());
                      if (formik?.values?.custName && !formik?.values?.accountName) {
                        dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: formik?.values?.custName?.id }))
                      }
                      if (formik?.values?.custName && formik?.values?.accountName) {
                        dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: formik?.values?.accountName?.id }))
                      }
                      else {
                        dispatch(getAssessmentTemplate())
                      }
                      // setCopyLoading(false);
                    }, 2000);
                  }
                  if (res?.payload?.error) {
                    setTimeout(() => {
                      dispatch(resetErrMessage());
                    }, 3000);
                  }
                })}
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <ArchiveIcon className={classes.iconResponsive} />
              </IconButton> :
                <IconButton
                 aria-label="unarchive"
                  onClick={() => dispatch(
                    updateArchivedAssessmentTemplate({

                      id: params?.row?.id,
                      isArchived: false

                    })
                  ).then((res) => {
                    if (res?.payload?.data?.ok) {
                      // setCopyLoading(true);
                      setTimeout(() => {
                        dispatch(resetMessage());

                        dispatch(getArchivedAssessmentTemplate({ assessmentCustomerId: formik.values.custName?.id, assessmentCustomerAccountId: formik?.values?.accountName?.id }));
                        // setCopyLoading(false);
                      }, 2000);
                    }
                    if (res?.payload?.error) {
                      setTimeout(() => {
                        dispatch(resetErrMessage());
                      }, 3000);
                    }
                  })}
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <UnarchiveIcon className={classes.iconResponsive} />
                </IconButton>


              }
            </MuiTooltip>
          );
        },
      },
      // )

     ...(!viewArchived ? [{
        field: "forceDelete",
        // headerName: 'Clone',
        type: "actions",
        hide: viewArchived ? true : false,

        width: 70,
        renderCell: (params) => {
          return (
            <MuiTooltip title="Force Delete" placement="right">
              <Link
                 aria-label="Force Delete"
                to="/exco/prepare"
                state={{
                  templateSelectedData: params?.row,
                  permissions: location?.state?.permissions,
                }}
              >
                {location?.state?.permissions?.find(
                  (e) =>
                    e.applicationService?.name?.split(".")[
                    e?.applicationService?.name?.split(".")?.length - 1
                    ] === "forceDelAssessTemp"
                ) && !params?.row?.isArchived && (
                    <IconButton
                     aria-label="delete"
                      sx={{ p: 0 }}
                      onClick={() => showForceDelete(params?.row)}
                    >
                      <DeleteIcon style={{ color: "#FF0000" }} />
                    </IconButton>
                  )}
              </Link>
            </MuiTooltip>
          );
        },
      }]:[]),

      {
        field: "detailedDescription",
        headerName: "Description",
        width: 450,
        renderCell: renderCellExpand,
      },
      {
        field: "customer",
        headerName: "Customer Name",
        width: 200,
        valueGetter: (value,  params) => params?.assessmentCustomerAccount?.assessmentCustomer?.
          customerName,

        renderCell: renderCellExpand,
      },
      {
        field: "account",
        headerName: "Account Name",
        width: 200,
        valueGetter: (value,  params) => params?.assessmentCustomerAccount?.accountName,

        renderCell: renderCellExpand,
      },
    ],
  };

  const formik = useFormik({
    reset: true,
    initialValues: {
      assessmentType: null,
      customerSelectedData: "",
      accountSelectedData: "",
      templateName: "",
      templateDisplayName: "",
      description: "",
      comments: "",
      custName: "",
      accountName: "",
      preTemplateName: "",
    },

    validationSchema: validationSchemaPreDefine,
    onSubmit: async (values, onSubmitProps) => {
      // templateCreation === "new"
      //   ? dispatch(
      //     createAssessmentTemplate({
      //       assessmentCustomerAccountId: values?.accountName?.id,
      //       assessmentTemplateName: values.templateName,
      //       assessmentTemplateDisplayName: values.templateDisplayName,
      //       assessmentType: values?.templateType?.assessmentType,
      //       detailedDescription: values.description,
      //       status: "New",
      //       comments: values.comments,
      //     })
      //   ).then((res) => {
      //     if (res?.payload?.data?.ok) {
      //       setTimeout(() => {
      //         dispatch(resetMessage());
      //         closeModel();
      //         values?.customerSelectedData && !values?.accountSelectedData ?
      //           dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: values?.customerSelectedData?.id }))
      //           : values?.accountSelectedData
      //             ? dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: values?.accountSelectedData?.id }))
      //             : dispatch(getAssessmentTemplate());


      //         onSubmitProps.resetForm();
      //       }, 2000);
      //     }
      //     if (res?.payload?.error) {
      //       setTimeout(() => {
      //         dispatch(resetErrMessage());
      //       }, 3000);
      //     }
      //   })
      // : 

      const res = await dispatch(
        createAssessmentTemplateByPreDefined({
          // assessmentTypeId:values?.assessmentType?.id,
          assessmentCustomerAccountId: values?.accountName?.id,
          id: values?.preTemplateName?.id,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeModel();
            selectedCustValue && !selectedAccountValue ?
              dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
              : selectedAccountValue
                ? dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
                : dispatch(getAssessmentTemplate());
            onSubmitProps.resetForm();
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });



  const formikEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      customerSelectedData: "",
      accountSelectedData: "",
      assessmentType: selectedData?.assessmentType?.id,
      templateName: selectedData?.assessmentTemplateName,
      templateDisplayName: selectedData?.assessmentTemplateDisplayName,
      custName: selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id,
      accountName: selectedData?.assessmentCustomerAccount?.id,
      description: selectedData?.detailedDescription,
      status: selectedData?.status,
      comments: selectedData?.comments,
    },

    validationSchema: editValidationSchema,
    onSubmit: async (values) => {

      const res = await dispatch(
        updateAssessmentTemplate({
          id: selectedData?.id,
          assessmentTypeId: values?.assessmentType,
          assessmentTemplateName: values.templateName,
          assessmentCustomerAccountId: values?.accountName,
          assessmentTemplateDisplayName: values.templateDisplayName,
          detailedDescription: values.description,
          status: values?.status,
          comments: values.comments,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeEditModal();
            selectedCustValue && !selectedAccountValue ?
              dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: selectedCustValue?.id }))
              : selectedAccountValue
                ? dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: selectedAccountValue?.id }))
                : dispatch(getAssessmentTemplate());
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });



  useEffect(() => {
    // dispatch(getAssessmentCompletedFramework({
    //   assessmentCustomerAccountId: formik?.values?.accountName?.id,
    //   assessmentCustomerId: formik?.values?.custName?.id, 
    //   assessmentTypeId: assessmentType?.id 
    // }));
    // dispatch(getAssessmentTemplate());
    dispatch(getPlatformStatus());
    dispatch(getCustomer())
    dispatch(getAssessmentTemplateConfig())
    dispatch(getassessmentType())
  }, []);

  // this use Effects is for once if the user selects the section the dimensiono level questions will display at
  // that time if he closes that page and clicks on the other assessment questions there the dimension level data still
  // it displays so we are resetting here
  useEffect(() => {
    try {
      dispatch(sectionRowSelect({}));
    } catch (err) {

    }
  }, []);

  // removed the below API call and given condition only if the assessmentype?.id is present then only API call
  // should happen and this issue is because if the user removes the assessment type in framework module and if he 
  // comes to this page that time assessment type data is null that time if the API calls without sending the id
  // backend throwing error
  useEffect(() => {
    if (assessmentType?.id) {
      dispatch(getAssessmentCompletedFramework({
        assessmentCustomerAccountId: selectedAccountDataList?.id,
        assessmentCustomerId: selectedCustomerDataList?.id,
        assessmentTypeId: assessmentType?.id
      }));
    }
  }, [assessmentType]);

  //storing the default value in both useState type and formik
  useEffect(() => {
    formik?.setFieldValue("assessmentType", !assessmentType ? assessmentTypeData?.find((data) => data.code === "ELI") : assessmentType)

    // setAssessmentType(assessmentType ? assessmentType : assessmentTypeData?.find((data) => data.code === "ELI"))
  }, [assessmentTypeData, assessmentType]);

  //  useEffect(() => {
  //    setAssessmentType(assessmentTypeData?.find((data) => data.code === "ELI"))
  //  }, [assessmentTypeData])

  useEffect(() => {
    // if assessment type is selected no need to call this use effect then the state variable it wont change so that time 
    // you will get the state variable stored and it will not be resetted everytime
    if (!Boolean(location?.state?.assessmentType) && assessmentTypeData?.length > 0) {
      const defaultType = assessmentTypeData.find(
        (data) => data.code === "ELI"
      );

      if (defaultType) {
        dispatch(setAssessmentType(defaultType));
        formik.setFieldValue("assessmentType", defaultType);
      }
    }
  }, [assessmentTypeData]);

  // resetting the assessment type data if the component unmounts and resetting the ELI Assessment
  // useEffect(() => {
  //   return() =>{
  //     dispatch(setAssessmentType(null));
  //   };
  // },[])

  useEffect(() => {
    if (formik.values?.custName?.id) {
      dispatch(getAccountById({ assessmentCustomerId: formik.values?.custName?.id }))
    }
  }, [formik.values?.custName])

  useEffect(() => {
    dispatch(getAccountById({ assessmentCustomerId: formikEdit.values?.custName?.id }))
    // if (!formikEdit.values?.custName) {
    //   formikEdit.setFieldValue("accountName", "")
    //   formikEdit.setFieldTouched("accountName", true)
    // }
  }, [selectedData && formikEdit.values?.custName])




  useEffect(() => {
    if (selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id) {
      dispatch(getAccountById({ assessmentCustomerId: selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id }))
      dispatch(getAssessmentCompletedFramework({
        assessmentCustomerAccountId: selectedData?.assessmentCustomerAccount?.id,
        assessmentCustomerId: selectedData?.assessmentCustomerAccount?.assessmentCustomer?.id,
        assessmentTypeId: selectedData?.assessmentType?.id

      }));
    }


  }, [selectedData])



  // useEffect(() => {
  //   if (!formikEdit?.values?.accountName) {
  //     let resultTwo = accountIdData?.find((dataThree) => dataThree?.id === selectedData?.assessmentCustomerAccount?.id)
  //     formikEdit.setFieldValue("accountName", resultTwo)
  //     formikEdit.setFieldTouched("accountName", true)
  //   }

  // }, [accountIdData])

  const getCustomerSelectedValue = (data) => {
    formik.setFieldValue("custName", data)
    setSelectedCustValue(data)
  }

  const getAccountSelectedValue = (data) => {
    formik.setFieldValue("accountName", data)
    setSelectedAccountValue(data)
  }

  const handleArchiveClick = () => {


    setViewArchived(!viewArchived);
    if (viewArchived === false) {
      dispatch(getArchivedAssessmentTemplate({ assessmentCustomerId: formik.values.custName?.id, assessmentCustomerAccountId: formik?.values?.accountName?.id }));
    }

    else {
      if (formik?.values?.custName && !formik?.values?.accountName) {
        dispatch(getAssessmentTemplateBycustomerId({ assessmentCustomerId: formik?.values?.custName?.id }))
      }
      if (formik?.values?.custName && formik?.values?.accountName) {
        dispatch(getAssessmentTemplateByAccountId({ assessmentCustomerAccountId: formik?.values?.accountName?.id }))
      }
      else {
        dispatch(getAssessmentTemplate())
      }

    }

  }
  const handleSubmit = async () => {
    if (showAdd) {
      const result = await formik.submitForm();
      return result;
    } else if (showEdit) {
      const result = await formikEdit.submitForm();
      return result;
    }
  };

  return (
    <>
      <>

        <HeaderDropDown heading=" Manage Assessment Templates" assessmentTypeData={assessmentTypeData} assessmentType={assessmentType} setAssessmentType={(value) => dispatch(setAssessmentType(value))} />

        {/* <PageHeader variant="pageHeader">
          Manage Assessment Templates
        </PageHeader> */}
        <MuiDataGrid

          maxHeight="700"
          handleArchiveClick={handleArchiveClick}
          viewArchived={viewArchived}
          isViewArchived={true}
          handleArchiveClick={ handleArchiveClick}

          setShowAdd={
            // location?.state?.permissions?.find(
            //   (e) =>
            //     e.applicationService?.name?.split(".")[
            //     e?.applicationService?.name?.split(".")?.length - 1
            //     ] === "createAssessTemp"
            // ) && 

            !viewArchived && showAddModel
          }
          setShowEdit={
            // location?.state?.permissions?.find(
            //   (e) =>
            //     e.applicationService?.name?.split(".")[
            //     e?.applicationService?.name?.split(".")?.length - 1
            //     ] === "updateAssessTemp"
            // ) &&

            !viewArchived && showEditModal
          }
          setShowDelete={
            // location?.state?.permissions?.find(
            //   (e) =>
            //     e.applicationService?.name?.split(".")[
            //     e?.applicationService?.name?.split(".")?.length - 1
            //     ] === "deleteAssessTemp"
            // ) && 
            !viewArchived && showDelete
          }
          // assessmentType={assessmentType}
          getAccountSelectedValue={(data) => getAccountSelectedValue(data)}
          getCustomerSelectedValue={(data) => getCustomerSelectedValue(data)}
          getCallBackCustomer={(data) => viewArchived ?
            getArchivedAssessmentTemplate({
              assessmentCustomerId: data,
              assessmentCustomerAccountId: selectedAccountDataList?.id
            })
            : getAssessmentTemplateBycustomerId({ assessmentCustomerId: data })}
          getCallBackOne={!viewArchived ? getAssessmentTemplate : getArchivedAssessmentTemplate}
          getCallBackThree={(data) => {

            viewArchived ?
              dispatch(getArchivedAssessmentTemplate({
                assessmentCustomerId: selectedCustomerDataList?.id,
                assessmentCustomerAccountId: data
              }))
              : dispatch(getAssessmentTemplateByAccountId({  assessmentCustomerAccountId: data }))
            dispatch(getAssessmentCompletedFramework({
              assessmentCustomerAccountId: data,
              assessmentCustomerId:selectedCustomerDataList?.id,
              assessmentTypeId: assessmentType?.id

            }))

          }



          }

          isAccount={true}
          isCustomer={true}
          // setShowAdd={showAddModel}
          // setShowEdit={showEditModal}
          // setShowDelete={showDelete
          // }

          toolbarColumn={true}
          // toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
          select={(data) => dispatch(rowSelect(data))}
        />
      </>

      {showGraph && <CommonCurdPopUp
        heading="Graphical View"
        mediumScreen={true}
        close={
          () => setShowGraph(false)
        }
      >

        <RadorGraph frameworkSelectedData={formik.values.preTemplateName} />

      </CommonCurdPopUp>}






      {showAdd && <CommonCurdPopUp
        heading="Create Assessment Template "
        mediumScreen={true}
        close={
          closeModel
        }
        handleSubmit={handleSubmit}
        loading={loading}
      >


        {/* <ModalPopUp
        open={showAdd}
        handleClose={closeModel}
        closeModel={closeModel}
      >
        <Box
        
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formik.handleSubmit}
        >
          <ModalCloseBtn close={closeModel} />
          <div className={classes.responsive_text}> */}
        <Grid container >

          {/* <Grid item xs={12} sm={12} md={11} >
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={(e, value) => {
                setTemplateCreation(value)
               
              }}
              row
              defaultValue="new"
              tabIndex={9}
              className="res_radioMargin"
            >
             
              <FormControlLabel
                checked={templateCreation === "pre-defined"}
                sx={{ width: "18rem" }}
                value="pre-defined"
                control={<Radio />}
                label="Assign Framework "
              />
            </RadioGroup>
          </Grid> */}

          {/* {templateCreation === "new" ? (
            <Grid item xs={12} sm={12} md={8} margin="auto">

              <MuiAutocomplete

                name="custName"
                options={customersData}
                setValue={(name, newValue) => {

                  formik.setFieldValue(name, newValue)
                  formik.setFieldValue("accountName", "")
                  formik.setFieldTouched("accountName", true)
                }
                }
                value={formik.values.custName}
                optionValue="customerName"
                label="Customer"
                required={true}
                error={formik.touched.custName && Boolean(formik.errors.custName)}
                helperText={formik.touched.custName && formik.errors.custName}
              />

              <MuiAutocomplete

                name="accountName"
                options={accountIdData}
                setValue={(name, newValue) => {
                  setSelectStateData({})
                  formik.setFieldValue(name, newValue)


                }
                }
                value={formik.values.accountName}
                optionValue="accountName"
                label="Accounts"
                required={true}
                error={formik.touched.accountName && Boolean(formik.errors.accountName)}
                helperText={formik.touched.accountName && formik.errors.accountName}
              />
              <MyTextInput
                label="Template Name"
                type="text"
                name="templateName"
                required={true}
                fullWidth={true}
                margin="normal"
                id="templateName"
                value={formik.values.templateName}
                onChange={formik.handleChange}
                tabIndex={1}
                error={
                  formik.touched.templateName &&
                  Boolean(formik.errors.templateName)
                }
                helperText={
                  formik.touched.templateName && formik.errors.templateName
                }
              />
              <MyTextInput
                label="Template Display Name"
                type="text"
                name="templateDisplayName"
                required={true}
                fullWidth={true}
                margin="normal"
                id="templateDisplayName"
                value={formik.values.templateDisplayName}
                onChange={formik.handleChange}
                tabIndex={1}
                error={
                  formik.touched.templateDisplayName &&
                  Boolean(formik.errors.templateDisplayName)
                }
                helperText={
                  formik.touched.templateDisplayName &&
                  formik.errors.templateDisplayName
                }
              />
              <MyTextInput
                label="Description"
                type="comments"
                name="description"
                required={true}
                fullWidth={true}
                margin="normal"
                id="description"
                value={formik.values.description}
                onChange={formik.handleChange}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />

            </Grid>) : ( */}

          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={11}
          // margin="auto"
          // sx={{ transition: "easing", transitionDuration: "60" }}
          >

            <MuiAutocomplete
              name="assessmentType"
              options={assessmentTypeData ? assessmentTypeData : []}
              setValue={(name, newValue) => {
                formik.setFieldValue(name, newValue)
                formik.setFieldValue("custName", "")
                formik?.setFieldValue("accountName", "")
              }
              }

              value={formik.values.assessmentType}
              optionValue="assessmentType"
              label="Assessment Type"
              required={true}
              error={formik.touched.assessmentType && Boolean(formik.errors.assessmentType)}
              helperText={formik.touched.assessmentType && formik.errors.assessmentType}
            />


            <MuiAutocomplete
              name="custName"
              options={customersData ? customersData : []}
              setValue={(name, newValue) => {
                formik.setFieldValue(name, newValue)
                formik.setFieldValue("accountName", "")
                formik?.setFieldValue("preTemplateName", "")
                dispatch(getAssessmentCompletedFramework({ assessmentCustomerAccountId: formik?.values?.accountName?.id, assessmentCustomerId: newValue?.id, assessmentTypeId: formik?.values?.assessmentType?.id }))
              }

              }
              value={formik.values.custName}
              optionValue="customerName"
              label="Customer"
              required={true}
              error={formik.touched.custName && Boolean(formik.errors.custName)}
              helperText={formik.touched.custName && formik.errors.custName}
            />

            <MuiAutocomplete
              name="accountName"
              options={formik.values.custName && accountIdData ? accountIdData : []}
              setValue={(name, newValue) => {
                formik.setFieldValue(name, newValue)
                formik?.setFieldValue("preTemplateName", "")
                dispatch(getAssessmentCompletedFramework({ assessmentCustomerAccountId: newValue?.id, assessmentCustomerId: formik?.values?.custName?.id, assessmentTypeId: formik?.values?.assessmentType?.id }))
              }

              }
              value={formik.values.accountName}
              optionValue="accountName"
              label="Accounts"
              required={true}
              error={formik.touched.accountName && Boolean(formik.errors.accountName)}
              helperText={formik.touched.accountName && formik.errors.accountName}
            />


            <Grid container>

              <Grid item sm={9} xs={9} md={formik.values.preTemplateName ? 11 : 12}>


                <MuiAutocomplete
                  name="preTemplateName"

                  options={
                    formik?.values?.accountName && assessmentFrameworkCompletedData?.length > 0 ?
                      assessmentFrameworkCompletedData : []
                  }
                  setValue={(name, newValue) => {
                    formik.setFieldValue(name, newValue);
                  }}
                  value={formik.values.preTemplateName}
                  optionValue="frameworkName"
                  label="Assessment Framework"
                  required={true}
                  error={
                    formik.touched.preTemplateName &&
                    Boolean(formik.errors.preTemplateName)
                  }
                  helperText={
                    formik.touched.preTemplateName &&
                    formik.errors.preTemplateName
                  }
                />

              </Grid>
              {formik.values.preTemplateName && (<Grid container item sm={3} xs={3} md={1} alignContent="center" justifyContent="end"  >
                <Grid item>

                  <MuiTooltip title="View Framework" placement="bottom">
                    {/* <Link
                      to="/exco/config/assessment-framework/spider-report"
                      state={{
                        frameworkSelectedData: formik.values.preTemplateName,
                        permissions: location?.state?.permissions,
                        componentName: "PREPARE"
                      }}
                    > */}
                    <IconButton aria-label="visibility" onClick={() => setShowGraph(true)} sx={{ p: 0 }}>
                      <VisibilityIcon style={{ color: "#00527d", fontSize: "35", marginTop: "1rem" }} />

                    </IconButton>

                    {/* </Link> */}
                  </MuiTooltip>

                </Grid>

              </Grid>)}

            </Grid>
            {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
          </Grid>
          {/* )} */}
        </Grid>
      </CommonCurdPopUp>}
      {/* </div> */}

      {/* <FormSubmitButton type="submit" variant="contained">
        Submit
      </FormSubmitButton> */}
      {/* </Box>
      </ModalPopUp> */}
      {/* <ModalPopUp
        open={showEdit}
        handleClose={() => setShowEdit(false)}
        closeModel={() => setShowEdit(false)}
      >
        <Box
         
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formikEdit.handleSubmit}
        >
          <ModalCloseBtn close={() => setShowEdit(false)} />
          <div className={classes.responsive_text}> */}
      {showEdit && <CommonCurdPopUp
        heading="Update Assessment Template "
        mediumScreen={true}
        close={
          closeEditModal
        }
        handleSubmit={handleSubmit}
        loading={loading}
      >


        <Grid container>
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} >
            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Assessment Type
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="assessmentType"
                defaultValue={formikEdit.values.assessmentType}
                value={formikEdit.values.assessmentType}
                label="Assessment Type"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.assessmentType &&
                  Boolean(formikEdit.errors.assessmentType)
                }
              >
                {assessmentTypeData?.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                    >
                      {option.assessmentType}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.accountName && formikEdit.errors.accountName}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Customer
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="custName"
                defaultValue={formikEdit.values.custName}
                value={formikEdit.values.custName}
                label="Customer"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.custName &&
                  Boolean(formikEdit.errors.custName)
                }
              >
                {customersData.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                    >
                      {option.customerName}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.custName && formikEdit.errors.custName}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Accounts
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="accountName"
                defaultValue={formikEdit.values.accountName}
                value={formikEdit.values.accountName}
                label="Accounts"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.accountName &&
                  Boolean(formikEdit.errors.accountName)
                }
              >
                {accountIdData?.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                    >
                      {option.accountName}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.accountName && formikEdit.errors.accountName}
              </FormHelperText>
            </FormControl>



            {/* 
                <MuiAutocomplete
                  name="custName"
                  options={customersData}
                  setValue={(name, newValue) => {
                    formikEdit.setFieldValue(name, newValue)
                    formikEdit.setFieldValue("accountName", "")
                    
                  }

                  }
                  value={formikEdit.values.custName}
                  optionValue="customerName"
                  label="Customer"
                  required={true}
                  error={formikEdit.touched.custName && Boolean(formikEdit.errors.custName)}
                  helperText={formikEdit.touched.custName && formikEdit.errors.custName}
                />

                <MuiAutocomplete
                  name="accountName"
                  options={accountIdData}
                  setValue={(name, newValue) =>
                    formikEdit.setFieldValue(name, newValue)
                  }
                  value={formikEdit.values.accountName}
                  optionValue="accountName"
                  label="Accounts"
                  required={true}
                  error={formikEdit.touched.accountName && Boolean(formikEdit.errors.accountName)}
                  helperText={formikEdit.touched.accountName && formikEdit.errors.accountName}
                /> */}
            <MyTextInput
              label="Template Name"
              type="text"
              name="templateName"
              required={true}
              fullWidth={true}
              margin="normal"
              id="templateName"
              defaultValue={formikEdit.values.templateName}
              value={formikEdit.values.templateName}
              onChange={formikEdit.handleChange}
              error={
                formikEdit.touched.templateName &&
                Boolean(formikEdit.errors.templateName)
              }
              helperText={
                formikEdit.touched.templateName &&
                formikEdit.errors.templateName
              }
            />

            <MyTextInput
             InputLabelProps={{shrink:true}}
              label="Template Display Name"
              type="text"
              name="templateDisplayName"
              required={true}
              fullWidth={true}
              margin="normal"
              id="templateDisplayName"
              defaultValue={formikEdit.values.templateDisplayName}
              value={formikEdit.values.templateDisplayName}
              onChange={formikEdit.handleChange}
              error={
                formikEdit.touched.templateDisplayName &&
                Boolean(formikEdit.errors.templateDisplayName)
              }
              helperText={
                formikEdit.touched.templateDisplayName &&
                formikEdit.errors.templateDisplayName
              }
            />
            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Template Status *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="status"
                defaultValue={formikEdit.values.status}
                value={formikEdit.values.status}
                label="Template Status"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.status &&
                  Boolean(formikEdit.errors.status)
                }
              >
                {assessmentTemplateStatusData.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.assessmentTemplateStatus}
                    >
                      {option.assessmentTemplateStatus}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.status && formikEdit.errors.status}
              </FormHelperText>
            </FormControl>
            <MyTextInput
              label="Description"
              type="comments"
              name="description"
              fullWidth={true}
              margin="normal"
              id="description"
              value={formikEdit.values.description}
              onChange={formikEdit.handleChange}
              error={
                formikEdit.touched.description &&
                Boolean(formikEdit.errors.description)
              }
              helperText={
                formikEdit.touched.description &&
                formikEdit.errors.description
              }
            />
            {/* <MyTextInput
                  label="Comments"
                  type="comments"
                  name="comments"
                  fullWidth={true}
                  margin="normal"
                  id="comments"
                  value={formikEdit.values.comments}
                  onChange={formikEdit.handleChange}
                  error={
                    formikEdit.touched.comments &&
                    Boolean(formikEdit.errors.comments)
                  }
                  helperText={
                    formikEdit.touched.comments && formikEdit.errors.comments
                  }
                /> */}
            {/* <Box style={{ width: "100%", textAlign: "center" }}>

              <FormSubmitButton onClick={formikEdit?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
          </Grid>
        </Grid>
        {/* </div> */}





      </CommonCurdPopUp>}





      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />

      <MicrositeConfirmDialog
        confirmDialog={forceDelConfirmDialog}
        setConfirmDialog={(obj) => handleSetForceDelConfirmDialog(obj)}
      />
      {(errMessage || assessmentErrMessage) && <ErrorNotifier message={errMessage || assessmentErrMessage} />}
      {message && <Notifier message={message} />}
    </>

  );
};

export default PrepareAssessments;
